import { CertsComponent } from '../components/certs/certs.component';
import { FileDetailComponent } from './../components/files/file-detail.component';
import { FileBrowseComponent } from './../shared/components/browse/file-browse.component';
import { EntityBrowseComponent } from './../shared/components/browse/entity-browse.component';
import { ConfirmationComponent } from './../shared/components/modal/confirmation/confirmation.component';
import { AuthGuard } from './../shared/guards/auth.guard';
import { CertDetailComponent } from '../components/certs/cert-detail.component';
import { GrantDetailComponent } from '../components/certs/grant-detail.component';

export const certsRoutes = {
    path: 'certs',
    data: {
        breadcrumbs: {
            label: 'Certifikáty',
            icon: 'certificates'
        },
        state: 'certs'
    },
    children: [
        {
            path: '',
            component: CertsComponent
        },
        {
            path: 'certs/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat certifikát'
                },
                state: 'cert-add'
            },
            children: [
                {
                    path: '',
                    component: CertDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'certs-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'certs-media-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'certs-entities-browse'
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'grants/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat grant'
                },
                state: 'grant-add'
            },
            children: [
                {
                    path: '',
                    component: GrantDetailComponent
                }
            ]
        },
        {
            path: 'certs/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit certifikát'
                },
                state: 'cert-edit'
            },
            children: [
                {
                    path: '',
                    component: CertDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'certs-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'certs-media-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'certs-entities-browse'
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'grants/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit grant'
                },
                state: 'grant-edit'
            },
            children: [
                {
                    path: '',
                    component: GrantDetailComponent
                }
            ]
        },
        {
            path: 'certs-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat certifikát'
                },
                state: 'certs-delete',
                apiUri: 'certificates'
            },
            outlet: 'modal'
        },
        {
            path: 'grants-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat grant'
                },
                state: 'grant-delete',
                apiUri: 'subsidies'
            },
            outlet: 'modal'
        }
    ],
    canActivate: [AuthGuard]
};
